import React from 'react';
import axios from 'axios';
import { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Contact(props) {
    const [inputField, setInputField] = useState({
        name: '',
        phone: '',
        msg: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputField(prev => ({ ...prev, [name]: value }));
    };

    const formSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        axios.post('https://singlewindowsecurities.com/rest3/contact_api/' + localStorage.getItem('userid'), {
            name: inputField.name,
            mobile: inputField.phone,
            message: inputField.msg,
            email: '',
            subject: 'Enq Mail'
        })
        .then((res) => {
            alert(res.data.msg);
            setInputField({ name: '', phone: '', msg: '' });
            navigate('/settings');
        })
        .catch((err) => {
            alert("Error submitting enquiry");
            console.error(err);
        })
        .finally(() => setIsLoading(false));
    };

    return (
        <div className="safearea" style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
        }}>
            <Helmet>
                <title>Contact Enquiry | Single Window Securities</title>
            </Helmet>

            {/* Modern Header */}
            <div style={{
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn me-2" style={{
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.3)',
                            borderRadius: '12px',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#D4AF37'
                        }}>
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0 fw-bold" style={{ color: '#D4AF37' }}>Contact Enquiry</h1>
                    </div>
                </div>
            </div>

            <main className="container py-4">
                <div style={{
                    background: 'rgba(20, 20, 20, 0.95)',
                    borderRadius: '24px',
                    border: '1px solid rgba(212, 175, 55, 0.2)',
                    overflow: 'hidden'
                }}>
                    <div className="p-4">
                        <form onSubmit={formSubmit}>
                            <div className="mb-4">
                                <label htmlFor="name" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    YOUR NAME
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={inputField.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="phone" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    PHONE NUMBER
                                </label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={inputField.phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter phone number"
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="msg" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    YOUR MESSAGE
                                </label>
                                <textarea
                                    id="msg"
                                    name="msg"
                                    rows="5"
                                    value={inputField.msg}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px',
                                        resize: 'vertical'
                                    }}
                                    placeholder="Type your message here..."
                                    required
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="btn w-100 py-3 mt-2 fw-bold"
                                disabled={isLoading}
                                style={{
                                    background: isLoading ? '#333' : 'linear-gradient(145deg, #D4AF37, #B8960C)',
                                    border: 'none',
                                    borderRadius: '16px',
                                    color: isLoading ? '#888' : '#000',
                                    fontWeight: 'bold',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isLoading) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" style={{ color: '#D4AF37' }} aria-hidden="true"></span>
                                        Submitting...
                                    </>
                                ) : (
                                    'Submit Enquiry'
                                )}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Support Info */}
                <div className="mt-4" style={{
                    background: 'rgba(20, 20, 20, 0.8)',
                    borderRadius: '20px',
                    border: '1px solid rgba(212, 175, 55, 0.15)',
                    padding: '16px'
                }}>
                    <div className="d-flex align-items-center mb-3">
                        <i className="fas fa-headset" style={{ color: '#D4AF37', fontSize: '24px', marginRight: '12px' }}></i>
                        <div>
                            <h6 className="mb-0 fw-bold" style={{ color: '#D4AF37' }}>24/7 Customer Support</h6>
                            <small style={{ color: '#888' }}>We're here to help you</small>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.1)' }}>
                        <div>
                            <small style={{ color: '#888' }}>Email</small>
                            <div style={{ color: '#D4AF37', fontSize: '13px' }}>support@singlewindowsecurities.com</div>
                        </div>
                        <div className="text-end">
                            <small style={{ color: '#888' }}>Phone</small>
                            <div style={{ color: '#D4AF37', fontSize: '13px' }}>
                                <a href='https://wa.me/message/3GFRRZF73FOPB1' target='_blank'>Connect with Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <style>
                {`
                    input:focus, textarea:focus {
                        box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
                        outline: none;
                        border-color: #D4AF37 !important;
                    }
                    input::placeholder, textarea::placeholder {
                        color: #666 !important;
                    }
                `}
            </style>
        </div>
    );
}